import React, { useState } from "react";
import Page from "../../Components/Page";
import { Box, Button, Card, CardContent, Typography } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import FetchHook from "../../Api/FetchHooks";

const CheckApprovals = () => {
  const location = useLocation();
  const loggedInUser = useSelector((state) => state?.auth?.user);

  const [loading, response, request] = FetchHook();

  const [user, setUser] = useState(location?.state?.user || loggedInUser);
  const [data, setData] = useState([]);

  const [dialog, setDialog] = useState({
    open: false,
    type: null,
    label: null,
  });
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "info",
  });

  const openDialog = (type, label) => setDialog({ open: true, type, label });
  const closeDialog = () => setDialog({ open: false, type: null, label: null });

  const handleSnackbarClose = () => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  const columns = [
    {
      field: "id",
      headerName: "Loan Id",
      width: 150,
    },
    {
      field: "cheque_no",
      headerName: "Cheque No",
      width: 150,
    },
    {
      field: "cheque_no",
      headerName: "Cheque No",
      width: 150,
    },
  ];

  return (
    <Page
      title={"Cheque Approval"}
      actions={
        <Box display={"flex"}>
          <Button
            variant="contained"
            startIcon={<AddIcon />}
            onClick={() => openDialog("upload_cheque", "Upload Cheque Form")}
          >
            Upload cheque
          </Button>
        </Box>
      }
    >
      <Card>
        <CardContent>Cheque Approval </CardContent>
      </Card>
    </Page>
  );
};

export default CheckApprovals;
